export const DEMO_STATE = {
	Filled: "isi",
	Empty: "kosong",
	Loading: "memuat",
	Error: "galat",
} as const;

export type DemoState = (typeof DEMO_STATE)[keyof typeof DEMO_STATE];

export const PARTNER_DEMO = {
	NewDataStep: "baru-data",
	NewContractStep: "baru-kontrak",
	NewActivationStep: "baru-aktivasi",
	Active: "aktif",
} as const;

export type PartnerDemo = (typeof PARTNER_DEMO)[keyof typeof PARTNER_DEMO];

const DEMO_STATE_PARAM = "demo";
const PARTNER_DEMO_PARAM = "mitra";
const DEMO_STORAGE_PREFIX = "portal-demo-";
const PRODUCTION_MODE = "production";

// Demo switches off in production.
const isDemoAllowed = import.meta.env.MODE !== PRODUCTION_MODE;

export const readDemoQueryParam = (parameterName: string): string | null =>
	isDemoAllowed && typeof window !== "undefined"
		? new URLSearchParams(window.location.search).get(parameterName)
		: null;

const DEMO_STATE_VALUES: readonly string[] = Object.values(DEMO_STATE);
const PARTNER_DEMO_VALUES: readonly string[] = Object.values(PARTNER_DEMO);

// Query param wins, then session.
const readDemoValue = (
	parameterName: string,
	allowedValues: readonly string[],
): string | undefined => {
	if (!isDemoAllowed || typeof window === "undefined") return undefined;
	const storageKey = DEMO_STORAGE_PREFIX + parameterName;
	const fromQuery = readDemoQueryParam(parameterName);
	try {
		if (fromQuery && allowedValues.includes(fromQuery)) {
			sessionStorage.setItem(storageKey, fromQuery);
			return fromQuery;
		}
		const fromSession = sessionStorage.getItem(storageKey);
		return fromSession && allowedValues.includes(fromSession)
			? fromSession
			: undefined;
	} catch {
		return fromQuery && allowedValues.includes(fromQuery)
			? fromQuery
			: undefined;
	}
};

// Page-only, never persisted.
export const readDemoState = (): DemoState => {
	const fromQuery = readDemoQueryParam(DEMO_STATE_PARAM);
	return fromQuery && DEMO_STATE_VALUES.includes(fromQuery)
		? (fromQuery as DemoState)
		: DEMO_STATE.Filled;
};

export const readPartnerDemo = (): PartnerDemo | undefined =>
	readDemoValue(PARTNER_DEMO_PARAM, PARTNER_DEMO_VALUES) as
		| PartnerDemo
		| undefined;
